import React from "react";

const emptyResults = () => (
  <div className="card w-75 mx-auto mt-4">
    <div className="card-body">
      <div className="card-title">
        <h4 className="fw-bold">No media people found matching this search.</h4>
      </div>
      <hr />
      <p>Try a name, an outlet, or a beat you are interested in.</p>
      <p className="mb-0">A little tweak to your search could really sweeten your results!</p>
    </div>
  </div>
);

export default emptyResults;
